



import { Component, Vue, Prop } from "vue-property-decorator";
import ParticaList2Line from "@/Ui-Components/Common/List/ParticaList2LineV3.vue";
import { ListItemDTO } from "../../Generated/ParticaAPI";
import { ParticaListContent, ParticaListLineContent } from "../../Models/ParticaListModel";
import { IArticle } from "../../Models/ArticleModels/article";
import { ParticaEvent } from "../../Models/ParticaEvent";
import { ButtonConfig } from "../../Models/Buttons";
@Component({
	name: "ArticleListXl",
	components: { ParticaList2Line }
})
export default class ArticleListXl extends Vue {
	@Prop() private data: IArticle[];
	@Prop() private buttons: ButtonConfig[];

	private listcontent() {
		const content: ParticaListContent = new ParticaListContent();
		this.data.forEach(article => {
			const line: ParticaListLineContent = new ParticaListLineContent();
			line.image = article.getFeaturedImage(this.$store.state.config.thumburl, 300);
			line.title = article.title;
			line.right = `$${article.price / 100}`;
			line.subtitle = article.abstract;
			line.id = article.articleId as string;
			content.lines.push(line);

		});
		return content;
	}

	private eventHandler(event: ParticaEvent) {
		this.$emit("partica-event", event);
	}

	private async mounted() {
		if (this.buttons === undefined) {
			throw new Error("buttons is undefined.");
		}
		if (this.data === undefined) {
			throw new Error("data is undefined.");
		}
	}
}
